import React from 'react';
import Tile from '../../../common/components/Tile/Tile';
import { List as ListIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';
import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';

const CommandJobs = (props) => {
  return (
    <Tile
      TitleIcon={ListIcon}
      title={'Command jobs'}
      helpTag="command_jobs"
      RightContent={
        <div>
          <PermissionsCheck permission={PermissionsEnum.CREATE_COMMAND_JOBS}>
            <Button
              variant="contained"
              data-qa="qa-newCommandJob"
              className="u-ml-double"
              color="primary"
              onClick={() => props.newCommandJob()}
            >
              NEW COMMAND JOB
            </Button>
          </PermissionsCheck>
        </div>
      }
    >
      <TableEnhancedContainer
        data={props.data}
        onClickRow={props.onClickRow}
        className="CommandJobsTable"
        columns={props.columnConfigs}
        enableHideColumns={true}
        enableActionButtons={true}
      />
    </Tile>
  );
};

export default CommandJobs;
